import React, { useState, useRef, useEffect } from "react";
import {
  Row,
  Col,
  Dropdown,
  Button,
  Modal,
  Container,
  Card,
  Form,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import Loader from "../../components/Loader/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../assets/css/brand.css";
import Swal from "sweetalert2";
import { Toaster } from "../../components/Toaster/Toster";
import Switch from "react-switch";
import ReactPaginate from "react-paginate";
import moment from "moment";
import Select from "react-select";
import {
  addFittingSizeApi,
  deleteFittingSizeApi,
  GetEditFittingSizeData,
  getFittingSizeApi,
  UpdateFittingSize,
  UpdateFittingSizeStatus,
} from "../../../services/apis/FittingSize";
import DeleteWarningMdl from "../../components/common/DeleteWarningMdl";
import useDebounce from "../../components/common/Debounce";
import uplodIcon from "../../../assets/images/upload-icon.png";
import { addBrandsApi } from "../../../services/apis/BrandApi";
import { getAllEventApi } from "../../../services/apis/EventMangement/CreateEventApi";
import { addBannerApi } from "../../../services/apis/Banners";

const theadData = [
  { heading: "S.No.", sortingVale: "sno" },
  { heading: "Banner", sortingVale: "banners" },
  { heading: "Created At", sortingVale: "created_at" },
  { heading: "Status", sortingVale: "status" },
  { heading: "Action", sortingVale: "action" },
];

const Banners = () => {
  const [sort, setSortata] = useState(10);
  const [loading, setLoading] = useState(false);
  const [modalCentered, setModalCentered] = useState(false);
  const [logo, setLogo] = useState(null);
  const [data, setData] = useState(
    document.querySelectorAll("#holidayList tbody tr")
  );
  const [formData, setFormData] = useState({
    event_id: "",
  });
  const [UpdateCategory, setUpdateCategory] = useState(false);
  const [fittingSizeList, setFittingSizeList] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editCategoryId, setEditCategoryId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const [error, setErrors] = useState(null); // To manage the error state
  const activePag = useRef(0);
  const [test, settest] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showDeleteMdl, setShowDeleteMdl] = useState(false);
  const [deleteTableDataId, setDeleteTableDataId] = useState("");
  const debouncedSearchValue = useDebounce(searchInputValue, 500);
  const [images, setImages] = useState([]); // Store new images
  const [oldImages, setOldImages] = useState([]); // Store existing images
  const [eventOption, setEventOption] = useState([]);
  const [selectedEventOption, setSelectedEventOption] = useState(null);
  // Handle new image uploads

  const handleImageChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setImages((prev) => [...prev, ...selectedFiles]);
  };

  // Remove newly uploaded image
  const handleRemoveImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  // Remove existing image (simulate deletion)
  const handleRemoveOldImage = (index) => {
    setOldImages(oldImages.filter((_, i) => i !== index));
  };

  const resetForm = () => {
    setFormData({
      event_id: "",
    });
    setLogo(null); // Reset the displayed image
    setErrors({}); // Clear errors
  };

  const getAllEventList = async () => {
    setLoading(true);
    try {
      const response = await getAllEventApi();
      const resData = response?.data;
      if (resData?.success) {
        const mappedData =
          resData?.events?.map((val) => ({
            value: val?._id,
            label: val?.event_title,
          })) || [];
        setEventOption(mappedData);
      }
    } catch (error) {
      console.error("Error fetching cuisines:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllEventList();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    // if (!formData.size) newErrors.size = "Size is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value, // Dynamically update the field (name, etc.)
    });
    setErrors({
      ...error,
      size: "",
    });
  };

  //   getSubCategoriesApi
  const fetchBanners = async (sortValue) => {
    // Set loading to true when the API call starts
    setLoading(true);
    try {
      const res = await getFittingSizeApi(
        currentPage,
        sort,
        sortValue,
        searchInputValue
      );

    } catch (error) {
      // Catch and handle errors
      console.error("Error fetching :", error);
      Toaster.error("Failed to load . Please try again.");
    } finally {
      // Always set loading to false when the API call is done (whether successful or failed)
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, [UpdateCategory, currentPage, sort, debouncedSearchValue]);


  const handleUpdateSubmit = async () => {
    const fData = new FormData();
    fData.append("event_id", formData.event_id);

    oldImages.forEach((url) => {
      fData.append("banner", url);
    });

    images.forEach((file) => {
      fData.append("banner", file);
    });

    try {
      const res = await UpdateFittingSize(editCategoryId, fData);
      // console.log("ressss", res);
      if (res.status) {
        setUpdateCategory(true);
        Toaster.success(res?.data?.message);
        resetForm();
        setModalCentered(false);
        setIsEdit(false);

        fetchBanners();
        setSelectedOption(null);
      } else {
        Toaster.error(
          res?.data?.message || "Something went wrong. Please try again."
        );
      }
    } catch (error) {
      Toaster.error(
        error.response?.data?.message || "An error occurred. Please try again."
      );
      console.error("Error:", error.message);
    } finally {
      setLoading(false); // Stop the loader
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return; // If validation fails, do not proceed further
    }
    if (isEdit) {
      handleUpdateSubmit();
    } else {
      setLoading(true); // Start the loader
      const fData = new FormData();
      
      fData.append("event_id", formData?.event_id);
      
      oldImages.forEach((url) => {
        fData.append("banner", url);
      });
      // Append new images (as files under "banner" key)
      images.forEach((file) => {
        fData.append("banner", file);
      });
      try {
        const res = await addBannerApi(fData);
        // console.log("ressss", res?.data?.success);
        if (res?.data?.success) {
          Toaster.success(res?.data?.message); // Display success message
          setFormData({
            event_id:""
          })
          setSelectedEventOption(null)
          setImages([]);
          setOldImages([]);
          }
      } catch (error) {
        // If there's an error in the request itself (network error, timeout, etc.)
        Toaster.error(
          error.response?.data?.message);
          console.error("Error:", error.message);
      } finally {
        setLoading(false); // Stop the loader
      }
    }
  };

  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };

  useEffect(() => {
    setData(document.querySelectorAll("#holidayList tbody tr"));
  }, [test]);

  activePag.current === 0 && chageData(0, sort);

  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  function SotingData(name, ind) {
    if (iconData.complete) {
      const sortValue = { value: name, type: "asc" };
      fetchBanners(sortValue);
    } else {
      const sortValue = { value: name, type: "dsc" };
      fetchBanners(sortValue);
    }
  }

  const handleEditFittingSize = async (id) => {
    try {
      const res = await GetEditFittingSizeData(id);
      if (res?.data?.success) {
        const data = res?.data?.fittingSize;

        setEditCategoryId(data?._id);
        setFormData({
          size: data?.size,
          measurementUnit: data?.measurementUnit,
        });
        // setModalCentered(true);
        setIsEdit(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteFittingSize = (id) => {
    setDeleteTableDataId(id);
    setShowDeleteMdl(true);
  };

  const handleDeleteSubmit = async () => {
    try {
      const res = await deleteFittingSizeApi(deleteTableDataId);
      //   console.log("response",res);
      if (res.status === 200) {
        Toaster.success(res?.data?.message); // Display success message
        fetchBanners();
        setDeleteTableDataId("");
        setShowDeleteMdl(false);
      } else {
        Toaster.error(
          res?.data?.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleStatusChange = async (FittingSizeId, currentStatus) => {
    const fdata = {
      isActive: !currentStatus,
    };
    try {
      const res = await UpdateFittingSizeStatus(FittingSizeId, fdata);
      if (res.status === 200) {
        Toaster.success(res?.data?.message); // Display success message
        fetchBanners();
      } else {
        Toaster.error(
          res?.data?.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      console.log(err);
    }

    // console.log("newStatus",newStatus)
  };

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  return (
    <>
      <DeleteWarningMdl
        title={"table data"}
        showDeleteMdl={showDeleteMdl}
        setShowDeleteMdl={setShowDeleteMdl}
        setDeleteTableDataId={setDeleteTableDataId}
        handleDeleteSubmit={handleDeleteSubmit}
      />

      <ToastContainer />
      <Loader visible={loading} />
      <PageTitle
        activeMenu={"Banners"}
        motherMenu={"Home"}
        motherMenuLink={"/dashboard"}
      />

      {/* SECTION 3RD Restaurant Info*/}
      <div className="col-xl-12 col-lg-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Banners (maximum 12)</h4>
          </div>
          <div className="card-body">
            <div>
              <div className="mb-3 row mt-3">
                <div className="row my-3">
                  <div className="col-sm-3 ">
                    <label className="col-sm-6 col-form-label">Event</label>
                    <Select
                      value={selectedEventOption}
                      onChange={(option) => {
                        setSelectedEventOption(option);
                        setFormData({
                          ...formData,
                          event_id: option.value,
                        });
                      }}
                      defaultValue={selectedEventOption}
                      options={eventOption}
                      style={{
                        lineHeight: "40px",
                        color: "#7e7e7e",
                        paddingLeft: " 15px",
                      }}
                    />
                    {error?.event && (
                      <span className="text-danger fs-12">{error?.event}</span>
                    )}
                  </div>

                  <div className="mt-4">
                    <label className="col-sm-6 col-form-label">Banner</label>
                    <div className="d-flex ">
                      <div className="creat_eevent-media-hub-uploadImageContainer">
                        <input
                          type="file"
                          accept="image/*"
                          name="image"
                          style={{ display: "none" }}
                          id="multipleImages"
                          multiple
                          onChange={handleImageChange}
                        />

                        <label
                          htmlFor="multipleImages"
                          className="imgPlaceholder"
                        >
                          <div className="flex flex-col cursor-pointer imgUploadIcon">
                            <img width="30" src={uplodIcon} alt="Upload Icon" />
                            <p>Select Banners</p>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                  {/* Display Existing Images (from DB) */}
                  <div className="MediaHub-selected-images">
                    {oldImages?.map((image, index) => (
                      <div
                        key={`old-${index}`}
                        className="MediaHub-image-preview">
                        <img
                          src={image}
                          alt={`Old ${index}`}
                          width="100"
                          className="m-2"
                        />
                        <button
                          onClick={() => handleRemoveOldImage(index)}
                          className="MediaHub-deleteImageButton"
                        >
                          ⛌
                        </button>
                      </div>
                    ))}
                  </div>

                  {/* Display New Images */}
                  <div className="MediaHub-selected-images">
                    {images?.map((image, index) => (
                      <div
                        key={`new-${index}`}
                        className="MediaHub-image-preview"
                      >
                        <img
                          src={URL.createObjectURL(image)}
                          alt={`New ${index}`}
                          width="100"
                          className="m-2"
                        />
                        <button
                          onClick={() => handleRemoveImage(index)}
                          className="MediaHub-deleteImageButton"
                        >
                          ⛌
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-end p-3">
            <button
              type="submit"
              onClick={handleSubmit}
              className="btn btn-primary rounded-sm"
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      <Row>
        <Col lg={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Banners List</h4>
              {/* <Link to={"/add-staff"} className="btn btn-primary">+ Add New</Link> */}
              {/* <Button
                variant="primary"
                type="button"
                className="mb-2 me-2"
                onClick={handleAddNewBrand}
              >
                + Add New Sub Category
              </Button> */}
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div id="holidayList" className="dataTables_wrapper no-footer">
                  <div className="justify-content-between d-sm-flex">
                    <div className="dataTables_length">
                      <label className="d-flex align-items-center">
                        Show
                        <Dropdown className="search-drop">
                          <Dropdown.Toggle as="div" className="search-drop-btn">
                            {sort}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => setSortata("2")}>
                              2
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("5")}>
                              5
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("10")}>
                              10
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("15")}>
                              15
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("20")}>
                              20
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        entries
                      </label>
                    </div>
                    <div className="dataTables_filter">
                      <label>
                        Search :
                        <input
                          type="search"
                          className=""
                          placeholder=""
                          onChange={(e) => setSearchInputValue(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                  <table
                    id="example4"
                    className="display dataTable no-footer w-100"
                  >
                    <thead>
                      <tr>
                        {theadData?.map((item, ind) => {
                          return (
                            <th
                              key={ind}
                              onClick={() => {
                                SotingData(item?.sortingVale, ind);
                                setIconDate((prevState) => ({
                                  complete: !prevState.complete,
                                  ind: ind,
                                }));
                              }}
                            >
                              {item.heading}
                              <span>
                                {ind !== iconData.ind && (
                                  <i
                                    className="fa fa-sort ms-2 fs-12"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                                {ind === iconData.ind &&
                                  (iconData.complete ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-12"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-12"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ))}
                              </span>
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {fittingSizeList?.fittingSizes?.map((data, ind) => (
                        <tr key={ind}>
                          <td>
                            <strong>{ind + 1}</strong>
                          </td>
                          <td>{data?._id}</td>

                          <td className="d-flex align-items-center gap-2">
                            {data?.size}
                          </td>

                          <td className="">{data?.measurementUnit}</td>

                          <td>
                            {moment(data?.created_at).format(
                              "DD MMM YYYY, h:mm:ss a"
                            )}
                          </td>
                          <td>
                            <Switch
                              checked={data?.isActive}
                              onChange={() =>
                                handleStatusChange(data?._id, data?.isActive)
                              }
                              offColor="#f0f1ff"
                              onColor="#6a73fa"
                              offHandleColor="#6a73fa"
                              onHandleColor="#fff"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              width={40} // Adjust width of the switch
                              height={20} // Adjust height of the switch
                            />
                          </td>
                          <td>
                            <button
                              className="btn btn-xs sharp btn-primary me-1"
                              onClick={() => handleEditFittingSize(data?._id)}
                            >
                              <i className="fa fa-pencil" />
                            </button>
                            <button
                              className="btn btn-xs sharp btn-danger"
                              onClick={() => handleDeleteFittingSize(data?._id)}
                            >
                              <i className="fa fa-trash" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div>
                    {/* {brandList?.data?.length < brandList?.total && ( */}
                    <div className="d-sm-flex text-center justify-content-end align-items-center mt-3">
                      <div className="pagination-container">
                        <ReactPaginate
                          pageCount={Math.ceil(
                            fittingSizeList?.totalFittingSizes /
                              fittingSizeList?.rowsPerPage
                          )}
                          pageRangeDisplayed={1}
                          marginPagesDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName="pagination"
                          activeClassName="selected"
                          disabledClassName="disabled"
                        />
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Banners;
